module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    key: _vm.handler,
    staticClass: "ql-script-marker",
    class: [
      ("ql-script-marker-" + _vm.markerTypeClass),
      {
        'ql-script-marker-locked': _vm.locked || !_vm.editable,
        'ql-script-marker-editing': _vm.editing || _vm.inlineEditing,
        'ql-script-marker--multiline': _vm.isMultiline,
        'show-md-dark-mode': _vm.showMode
      }
    ],
    style: (_vm.markerStyle),
    attrs: {
      "handles": [],
      "resizable": false,
      "draggable": _vm.editable && !_vm.locked && !_vm.inlineEditing,
      "prevent-deactivation": _vm.inlineEditing || _vm.keepEditing,
      "drag-cancel": ".ql-script-marker-actions",
      "x": _vm.posLeft,
      "y": _vm.posTop,
      "w": _vm.markerWidth,
      "h": _vm.markerHeight,
      "parent": true
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    },
    nativeOn: {
      "mousedown": function($event) {
        return _vm.selectForCopy.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "ql-script-marker-body"
  }, [(_vm.marker.type === 'song') ? _c('span', {
    staticClass: "ql-script-marker-type-glyph",
    attrs: {
      "aria-label": "Song"
    }
  }, [_vm._v("♪")]) : _vm._e(), _vm._v(" "), (_vm.inlineEditing) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editLabel),
      expression: "editLabel"
    }],
    ref: "inlineInput",
    staticClass: "ql-script-marker-inline-input",
    domProps: {
      "value": (_vm.editLabel)
    },
    on: {
      "keydown": _vm.onInlineKeydown,
      "blur": _vm.commitInlineEdit,
      "click": function($event) {
        $event.stopPropagation();
      },
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editLabel = $event.target.value
      }
    }
  })] : _c('span', {
    ref: "label",
    staticClass: "ql-script-marker-label",
    attrs: {
      "title": _vm.tooltipText
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectMarker.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.displayLabel))])], 2), _vm._v(" "), (_vm.editing && _vm.editable && !_vm.locked && !_vm.inlineEditing) ? _c('div', {
    staticClass: "ql-script-marker-actions"
  }, [_c('span', {
    staticClass: "ql-script-marker-action",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onMarkerEditClick.apply(null, arguments)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onMarkerEditClick.apply(null, arguments)
      }
    }
  }, [_c('md-icon', [_vm._v("edit")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Edit")])], 1), _vm._v(" "), _c('span', {
    staticClass: "ql-script-marker-action",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onMarkerDeleteClick.apply(null, arguments)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onMarkerDeleteClick.apply(null, arguments)
      }
    }
  }, [_c('md-icon', [_vm._v("clear")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete")])], 1)]) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "deleteDialog",
    attrs: {
      "md-title": "Delete marker",
      "md-content-html": _vm.deleteConfirmHtml,
      "md-ok-text": "Delete",
      "md-cancel-text": "Cancel"
    },
    on: {
      "close": _vm.onDeleteConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aca4f23a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/markers/script-marker.vue
// module id = 1282
// module chunks = 21